import './recruit-class.styles.scss';
import { STATES } from '@shared/places.js';
import { positions } from '@/utils/positions';

// The high school recruits committed to a team for next season
// (team.recruits). Nothing when there are none, unless `empty` text is
// given.
const RecruitClass = ({ team, title = 'Recruiting class', empty, children }) => {
    const list = team.recruits ?? [];
    if (!list.length && !empty && !children) return null;
    const sorted = [...list].sort((a, b) => b.stars - a.stars || a.lName.localeCompare(b.lName));
    return (
        <div className='g-card recruit-class'>
            <h3>{title}</h3>
            {sorted.length === 0 ? <p className='meta'>{empty}</p> :
                <ul>
                    {sorted.map(r => (
                        <li key={r.id}>
                            <span>
                                <b>{r.fName} {r.lName}</b>{' '}
                                <span className='meta'>{positions[r.pos1 - 1]?.short} · {Math.floor(r.height / 12)}&apos;{r.height % 12}&quot;{r.homeState ? ` · ${STATES[r.homeState] ?? r.homeState}` : ''}</span>
                            </span>
                            <span className='class-stars' aria-label={`${r.stars} stars`}>{'★'.repeat(r.stars)}<span>{'★'.repeat(5 - r.stars)}</span></span>
                        </li>
                    ))}
                </ul>
            }
            {children}
        </div>
    )
}

export default RecruitClass
